query GetAfterEffectsApiInfo {
    afterEffectsApiInfo {
        url
    }
}
